import {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {ChevronLeft, ChevronRight} from "lucide-react";
import {api, LOGO_ON_TOSCA, LOGO_ON_WHITE} from "@/lib/inner";

export default function StaffLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@inner.demo"), [password, setPassword] = useState("InnerDemo123!"), [error, setError] = useState("");
  const submit = async e => {
    e.preventDefault();
    try {
      const r = await api.post("/auth/login", {email, password});
      localStorage.setItem("inner_token", r.data.token);
      localStorage.setItem("inner_user", JSON.stringify(r.data.user));
      nav("/dashboard");
    } catch (err) { setError(err.response?.data?.detail || "Tidak dapat masuk"); }
  };
  return <main className="login-page">
    <div className="login-art"><img src={LOGO_ON_TOSCA} alt="INNER Salon Muslimah"/><h1>Operasional yang<br/><em>lebih tenang.</em></h1><p>Kelola jadwal, reservasi, dan pengalaman setiap muslimah dengan lebih mudah.</p></div>
    <form className="login-form" onSubmit={submit}>
      <Link className="back-link" to="/"><ChevronLeft/> Beranda</Link>
      <img className="login-mobile-logo" src={LOGO_ON_WHITE} alt="INNER Salon Muslimah"/>
      <p className="eyebrow">AREA STAF · AKUN DEMO</p>
      <h2>Selamat datang<br/>kembali.</h2>
      <p className="muted">Masuk untuk membuka jadwal dan reservasi outlet.</p>
      <label>Email<input data-testid="staff-email-input" type="email" value={email} onChange={e => setEmail(e.target.value)}/></label>
      <label>Kata sandi<input data-testid="staff-password-input" type="password" value={password} onChange={e => setPassword(e.target.value)}/></label>
      {error && <div className="error" data-testid="staff-login-error">{error}</div>}
      <button className="primary-btn full" data-testid="staff-login-button">Masuk ke dashboard <ChevronRight/></button>
      <small className="demo-hint">Demo: admin@inner.demo · InnerDemo123!</small>
    </form>
  </main>;
}
